export interface Bid {
  id: string
  reference: string
  title: string
  category: string
  publicationDate: string
  deadline: string
  status: 'open' | 'closing-soon' | 'closed'
  description: string
  estimatedValue?: string
}

export const bids: Bid[] = [
  {
    id: '1',
    reference: 'AU-AFRI-2026-001',
    title: 'Supply of Medical Equipment for AU Health Partnership Programme',
    category: 'Health & Medical',
    publicationDate: '2026-04-15',
    deadline: '2026-06-30',
    status: 'open',
    description:
      'Procurement of advanced medical diagnostic equipment for distribution across 15 African Union member states as part of the AU Health Systems Strengthening Initiative.',
    estimatedValue: '£2,500,000',
  },
  {
    id: '2',
    reference: 'AU-AFRI-2026-002',
    title: 'Construction of Trade Facilitation Centre in Accra',
    category: 'Infrastructure',
    publicationDate: '2026-04-20',
    deadline: '2026-06-15',
    status: 'closing-soon',
    description:
      "Design and construction of a modern trade facilitation centre to support AfCFTA implementation and Africa's global trade partnerships.",
    estimatedValue: '£8,750,000',
  },
  {
    id: '3',
    reference: 'AU-AFRI-2026-003',
    title: 'Digital Skills Training Programme Implementation',
    category: 'Education & Training',
    publicationDate: '2026-04-10',
    deadline: '2026-07-10',
    status: 'open',
    description:
      'Delivery of comprehensive digital skills training to 5,000 young professionals across AU member states, focusing on AI, data science, and software development.',
    estimatedValue: '£1,200,000',
  },
  {
    id: '4',
    reference: 'AU-AFRI-2026-004',
    title: 'Climate Finance Advisory Services',
    category: 'Consulting Services',
    publicationDate: '2026-03-28',
    deadline: '2026-06-05',
    status: 'closing-soon',
    description:
      'Expert advisory services for structuring climate finance instruments and green bonds for African infrastructure projects.',
    estimatedValue: '£650,000',
  },
  {
    id: '5',
    reference: 'AU-AFRI-2026-005',
    title: 'Agricultural Technology Transfer Programme',
    category: 'Agriculture',
    publicationDate: '2026-04-05',
    deadline: '2026-06-10',
    status: 'open',
    description:
      'Implementation of precision agriculture technologies and training for smallholder farmers in East Africa.',
    estimatedValue: '£3,200,000',
  },
  {
    id: '6',
    reference: 'AU-AFRI-2025-089',
    title: 'Renewable Energy Infrastructure Assessment',
    category: 'Energy',
    publicationDate: '2025-12-10',
    deadline: '2026-02-15',
    status: 'closed',
    description:
      'Comprehensive assessment of renewable energy infrastructure needs across 10 AU member states.',
    estimatedValue: '£450,000',
  },
  {
    id: '7',
    reference: 'AU-AFRI-2026-006',
    title: 'Diaspora Engagement Platform Development',
    category: 'Technology',
    publicationDate: '2026-04-18',
    deadline: '2026-06-05',
    status: 'open',
    description:
      'Development of a digital platform to connect the African diaspora worldwide with investment and partnership opportunities in Africa.',
    estimatedValue: '£850,000',
  },
  {
    id: '8',
    reference: 'AU-AFRI-2026-007',
    title: 'Women Entrepreneurs Support Programme',
    category: 'Economic Development',
    publicationDate: '2026-04-12',
    deadline: '2026-07-22',
    status: 'closing-soon',
    description:
      'Comprehensive support programme including training, mentorship, and access to finance for 1,000 women entrepreneurs across AU member states.',
    estimatedValue: '£1,800,000',
  },
  {
    id: '9',
    reference: 'AU-AFRI-2025-092',
    title: 'Transport Corridor Feasibility Study',
    category: 'Infrastructure',
    publicationDate: '2025-11-20',
    deadline: '2026-01-30',
    status: 'closed',
    description:
      'Feasibility study for multimodal transport corridor linking three AU member states.',
    estimatedValue: '£720,000',
  },
  {
    id: '10',
    reference: 'AU-AFRI-2026-008',
    title: 'Youth Leadership Development Programme',
    category: 'Education & Training',
    publicationDate: '2026-04-22',
    deadline: '2026-06-15',
    status: 'open',
    description:
      'Leadership training and exchange programme for 200 emerging African leaders aged 25-35.',
    estimatedValue: '£950,000',
  },
]
